import { Brand, Maybe, Price, ProductMedia } from '../../../../../types';
import {
  PriceDisplay,
  CurrentCampaign,
  ProductPriceType,
} from '../../../types';

export enum ReportRowType {
  NONE = 'none',
  DEFAULT = 'default',
  ALTERNATIVE = 'alternative',
}

export type TableLinkProps = {
  rel: string;
  href?: string;
  onClick: (e: React.MouseEvent) => void;
  target: string;
  disabled: boolean;
};

export type Align = 'left' | 'right';

export interface IPriceRowProps {
  alternativePrices: Price['alternativePrices'];
  brand?: Maybe<Brand>;
  brandRecommendedRetailer: boolean;
  campaign: CurrentCampaign | null;
  priceDisplay: PriceDisplay;
  deliveryOptions: Price['deliveryOptions'];
  externalUri?: string | null;
  isInternationalPrice: boolean;
  media: ProductMedia & { first?: string | null };
  name: Price['name'];
  onClickOutBounce: (id: number, priceId?: string | null) => void;
  onPriceClick: (
    featured: boolean,
    price: number | undefined,
    status: string,
    isAlternative: boolean,
    isSplitList?: boolean
  ) => void;
  openInNewWindow: boolean;
  price: Price['price'];
  priceId?: string | null;
  priceType?: ProductPriceType | null;
  productId: number;
  productName?: string;
  stock: Price['stock'];
  store: Price['store'];
  storeInfo?: (string | null)[] | null;
  isSplitList?: boolean;
}
